import React, { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, CircularProgress,
  Button, Box
} from "@mui/material";
import Layout from "./Layout";

export default function Patients() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  // Fetch patients from your backend
  useEffect(() => {
    fetch("http://127.0.0.1:8000/patients", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.status === 200) return res.json();
        throw new Error("Failed to load patients");
      })
      .then((data) => {
        setPatients(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [token]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <Layout title="Patient Records" onLogout={handleLogout}>
      <Typography variant="body1" gutterBottom>
        Below is a list of patients registered in the HealthLink system.
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : patients.length === 0 ? (
        <Typography>No patients found in the system.</Typography>
      ) : (
        <TableContainer component={Paper} sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>Name</b></TableCell>
                <TableCell><b>Age</b></TableCell>
                <TableCell><b>Gender</b></TableCell>
                <TableCell><b>Temperature (°C)</b></TableCell>
                <TableCell><b>Blood Pressure</b></TableCell>
                <TableCell><b>Heart Rate</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {patients.map((patient) => (
                <TableRow key={patient._id}>
                  <TableCell>{patient.name}</TableCell>
                  <TableCell>{patient.age}</TableCell>
                  <TableCell>{patient.gender}</TableCell>
                  <TableCell>{patient.temperature}</TableCell>
                  <TableCell>{patient.blood_pressure}</TableCell>
                  <TableCell>{patient.heart_rate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Layout>
  );
}
